export * from "-!../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--8-0!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js??ref--8-2!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/lib/index.js??ref--8-3!../../../node_modules/sass-loader/dist/cjs.js??ref--8-4!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Notifications.vue?vue&type=style&index=0&id=abcbebdc&prod&lang=scss&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/NotificationPlugin/Notifications.vue?vue&type=style&index=0&id=abcbebdc&prod&lang=scss&scoped=true
// module id = 2795
// module chunks = 31